module.exports = "/_next/static/media/a0f5f75a0182f2721e43369660e96b37.svg";